import { Component, OnInit } from '@angular/core';

import { DeviceBehfa_Interface } from 'src/app/Interface/DeviceBehfa_Interface';
import { CalibrationService } from 'src/app/Service/Calibration/Calibration.service';
import { CertificateService } from 'src/app/Service/Certificate/Certificate.service';
import { DashboardService } from 'src/app/Service/Dashboard/Dashboard.service';
import { DeviceBehfaService } from 'src/app/Service/DeviceBehfa/DeviceBehfa.service';
import { LoginService } from 'src/app/Service/Login/Login.service';
import { environment } from 'src/environments/environment';
import { Person_Interface } from 'src/app/Interface/Person_Interface';
import * as XLSX from 'xlsx';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { FundsService } from 'src/app/Service/Funds/Funds.service';
import { PM_ServiceService } from 'src/app/Service/PM/PM_Service.service';
import { PM_Service_Interface } from 'src/app/Interface/PM_Service_Interface';

@Component({
  selector: 'app-Dashboard',
  templateUrl: './Dashboard.component.html',
  styleUrls: ['./Dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  Token:string=""
  Fullname:String=""
  Almat_Ekhtesari:String=""
  Semat:String=""
  BaserUrlImage:string=environment.BaseUrl
  MyType:any;
  pmUser:number=0;
  MyCustomerName:any;

  DataList_Browser:Array<General_Interface>=[]
  modalRef_welcom:any

  constructor(
    private login_Service: LoginService,
    private Calibration_Service:CalibrationService,
    private Funds_Service:FundsService,
    private Certificate_Service:CertificateService,
    private DeviceBehfa_Service:DeviceBehfaService,
    private PM_Service_Service:PM_ServiceService,
    private Dashboard_Service:DashboardService,
  ) { }

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');
    this.Fullname=localStorage.getItem('Daro_User_Fullname');
    this.BaserUrlImage=this.BaserUrlImage+localStorage.getItem('Daro_User_UserImage')
    this.Procssing = true




    this.login_Service.GetUserRole(this.Token).subscribe(
      data=>{
        this.MyType=data['type']
        this.pmUser=data['pmUser']
        this.MyCustomerName=data['customerName']
        this.DataList_Browser=data['login']
        this.Almat_Ekhtesari=data['almat_Ekhtesari']
        this.Semat=data['semat']

        if(this.MyType==1 || this.MyType==2)
        {
          this.Read_GetDetailCount_Certificate()
        }
        else{
          this.Read_GetCustomerDashboard()
        }

      },error=>{
        localStorage.clear()
        location.reload();

      }
    )



  }


  //#region Admin

  Procssing:boolean=false

  funds_Recive:number=0
  funds_Pay:number=0
  funds_Has:number=0
  
  Type_ExpertDashboard:number=0

  mission:number=0
  suggestPoint:number=0
  total_point:number=0

  inlocation_amount:number=0
  outlocation_amount:number=0
  inlocation_certificate:number=0
  outlocation_certificate:number=0

  barabar_point:number=0
  tajil_point:number=0
  takhir_point:number=0
  month_point:number=0
  month_day_point:number=0

  Read_GetDetailCount() {
    this.Dashboard_Service.GetExpertDashboard(this.Type_ExpertDashboard,this.Token).subscribe(
      data=>{


        
        this.mission=data['mission']
        this.suggestPoint=data['suggestPoint']
        this.total_point=data['total_point']

        this.inlocation_amount=data['inlocation_amount']
        this.outlocation_amount=data['outlocation_amount']
        this.inlocation_certificate=data['inlocation_certificate']
        this.outlocation_certificate=data['outlocation_certificate']
        
        this.barabar_point=data['barabar_point']
        this.tajil_point=data['tajil_point']
        this.takhir_point=data['takhir_point']
        this.month_point=data['month_point']
        this.month_day_point=data['month_day_point']

        
      }
    )
    

 
  }


  set_Type_ExpertDashboard(input:number){
    this.Type_ExpertDashboard=input
    this.Read_GetDetailCount()
  }



  current_Month_Certificate:number=0
  current_Year_Certificate:number=0
  last_Month_Certificate:number=0

  Read_GetDetailCount_Certificate() {
    /*
    this.Certificate_Service.GetDetailCount(this.Token).subscribe(
      data=>{
        this.current_Month_Certificate=data['current_Month']
        this.current_Year_Certificate=data['current_Year']
        this.last_Month_Certificate = data['last_Month']
        this.Read_GetDetailCount_Fund()

      }
    )*/
    this.Read_GetDetailCount_Fund()
  }

  //#region DeviceBehfa
  two_Month_DeviceBehfa:Array<DeviceBehfa_Interface>=[]
  one_Month_DeviceBehfa:Array<DeviceBehfa_Interface>=[]
  zero_Month_DeviceBehfa:Array<DeviceBehfa_Interface>=[]
  type_DeviceBehfa:number=0

  Read_GetDetailCount_DeviceBehfa(){
    this.DeviceBehfa_Service.GetDetailCount(this.Token).subscribe(
      data => {

        this.type_DeviceBehfa=data['type']
        this.two_Month_DeviceBehfa=data['twoMonth']
        this.one_Month_DeviceBehfa=data['oneMonth']
        this.zero_Month_DeviceBehfa=data['zeroMonth']
        this.Procssing = false

        this.Read_PMServeice()
      }
    )
  }

  Read_GetDetailCount_Fund(){
    this.Funds_Service.GetCount(this.Token).subscribe(
      data => {
        this.funds_Recive=data[0]
        this.funds_Pay=data[1]
        this.funds_Has=data[2]
        this.Procssing=false
        this.Read_GetDetailCount_DeviceBehfa()
      }
    )
  }

  exportexcel_two_Month_DeviceBehfa(): void
  {
     /* table id is passed over here */
     let element = document.getElementById('excel-table_two_Month_DeviceBehfa');
     const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);

     /* generate workbook and add the worksheet */
     const wb: XLSX.WorkBook = XLSX.utils.book_new();
     XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

     /* save to file */
     XLSX.writeFile(wb, "BehfaDevice.xlsx");

  }

  exportexcel_one_Month_DeviceBehfa(): void
  {
     /* table id is passed over here */
     let element = document.getElementById('excel-table_one_Month_DeviceBehfa');
     const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);

     /* generate workbook and add the worksheet */
     const wb: XLSX.WorkBook = XLSX.utils.book_new();
     XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

     /* save to file */
     XLSX.writeFile(wb, "BehfaDevice.xlsx");

  }

  exportexcel_zero_Month_DeviceBehfa(): void
  {
     /* table id is passed over here */
     let element = document.getElementById('excel-table_zero_Month_DeviceBehfa');
     const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);

     /* generate workbook and add the worksheet */
     const wb: XLSX.WorkBook = XLSX.utils.book_new();
     XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

     /* save to file */
     XLSX.writeFile(wb, "BehfaDevice.xlsx");

  }

  //#endregion

  //#region PM

  unstart_PM_DataList:Array<PM_Service_Interface>=[]
  today_PM_DataList:Array<PM_Service_Interface>=[]
  week_PM_DataList:Array<PM_Service_Interface>=[]
  month_PM_DataList: Array<PM_Service_Interface> = []

  unstart_PM_DataList_page:number=0
  week_PM_DataList_page:number=0
  today_PM_DataList_page:number=0
  month_PM_DataList_page:number=0

  Read_PMServeice(){
    this.PM_Service_Service.GetDashboard(this.Token).subscribe(
      data => {
        this.unstart_PM_DataList=data['unstart']
        this.today_PM_DataList=data['today']
        this.week_PM_DataList=data['week']
        this.month_PM_DataList=data['month']
        this.Read_GetSuggest_Dashboard()
      }
    )
  }


  //#endregion


  //#endregion

  //#region Customer

  Calibration_Customer:number=0
  Calibration_Customer_Device_InLocation:number=0
  Calibration_Customer_Device_NotLocation:number=0
  Customer_User:Array<Person_Interface>=[]

  Read_GetCustomerDashboard(){
    this.Dashboard_Service.GetCustomerDashboard(this.Token).subscribe(
      data=>{
        this.Customer_User=data['user']
        this.Calibration_Customer=data['calibration']
        this.Calibration_Customer_Device_InLocation=data['device_InLocation']
        this.Calibration_Customer_Device_NotLocation=data['device_NotLocation']
      }
    )
  }

  //#endregion

  //#region Alert

  Switch_Alert_Form: string = 'Hidden'
  set_Switch_Alert_Form(value: string)
  {
    this.Switch_Alert_Form=value
  }

  //#endregion

  //#region Suggest

  amount_Suggest:number=0
  waitting_Suggest:number=0
  submited_Suggest:number=0
  point_Suggest:number=0
  last_Suggest:number=0

  Read_GetSuggest_Dashboard(){
    this.Dashboard_Service.GetSuggest(this.Token).subscribe(
      data=>{
        this.amount_Suggest=data['amountSuggest']
        this.waitting_Suggest=data['waitting']
        this.submited_Suggest=data['submited']
        this.point_Suggest=data['point']
        this.last_Suggest=data['lastSuggest']
        this.Read_GetDetailCount()
      }
    )
  }
  //#endregion


}
